import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { Dropdown, Badge } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';

const NAV = [
  { to: '/dashboard', label: 'Dashboard', icon: 'bi-speedometer2', roles: ['admin', 'sales', 'builder', 'support'] },
  { to: '/leads', label: 'Leads', icon: 'bi-person-lines-fill', roles: ['admin', 'sales', 'support'] },
  { to: '/projects', label: 'Projects', icon: 'bi-buildings', roles: ['admin', 'sales', 'builder', 'support'] },
  { to: '/bookings', label: 'Bookings', icon: 'bi-house-check', roles: ['admin', 'sales', 'support', 'builder'] },
  { to: '/payments', label: 'Payments', icon: 'bi-cash-coin', roles: ['admin', 'sales', 'support'] },
  { to: '/commissions', label: 'Commissions', icon: 'bi-wallet2', roles: ['admin', 'sales', 'support'] },
  { to: '/users', label: 'Users', icon: 'bi-people', roles: ['admin', 'support'] },
];

const Layout = () => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  if (!user) return null;
  const items = NAV.filter((n) => n.roles.includes(user.role));

  const roleColor = {
    admin: 'danger',
    sales: 'primary',
    builder: 'success',
    support: 'warning',
  }[user.role];

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand">
          <i className="bi bi-buildings-fill me-2"></i>Aaarya CRM
        </div>
        <nav className="d-flex flex-column gap-1">
          {items.map((it) => (
            <NavLink key={it.to} to={it.to} className="nav-link">
              <i className={`bi ${it.icon}`}></i> {it.label}
            </NavLink>
          ))}
        </nav>
      </aside>

      <div className="main">
        <header className="topbar">
          <div className="d-flex align-items-center gap-2">
            <Badge bg={roleColor} className="text-uppercase">
              {user.role}
            </Badge>
            <span className="text-muted small">Logged in as</span>
            <strong>{user.name}</strong>
          </div>
          <Dropdown align="end">
            <Dropdown.Toggle variant="light" size="sm">
              <i className="bi bi-person-circle me-1"></i>
              {user.email}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item disabled>{user.role.toUpperCase()}</Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item
                onClick={() => {
                  logout();
                  nav('/login');
                }}
              >
                <i className="bi bi-box-arrow-right me-1"></i>Sign out
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </header>

        <main className="content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
